export default __webpack_public_path__ + "static/media/Certificate_EN.ce2273b1.pdf";